/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 * 
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AB_ITEM_SEPARATOR as AB_ITEM_SEPARATOR_INTERNAL } from "abweb/collection/AbItemSeparator";
export const AB_ITEM_SEPARATOR = AB_ITEM_SEPARATOR_INTERNAL;
//# sourceMappingURL=AbItemSeparator.js.map
